import {
  EditOutlined,
  WarningOutlined,
  PlusOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { List, Modal, Row } from "antd";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PFButton from "../../../components/functional_components/Button/PFButton";
import { setFilters } from "../../../redux/ducks/Filters";
import { setLoading } from "../../../redux/ducks/Loading";
import ClientPortal from "../../../services/api/ClientPortal";
import { paginationDefaults } from "../../../utils/properties";
import { buildQueryString, showError, showSuccess } from "../../../utils/utilities";

const Clients = () => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const [state, setState] = useState({
    clientsList: [],
    pagination: {
      currentPage: paginationDefaults.page,
      size: paginationDefaults.size,
      totalItems: paginationDefaults.totalItems,
    },
    modal: {
      visible: false,
      type: "",
      data: {},
    },
  });

  useEffect(() => {
    dataList(filters.string);
  }, [filters.string]);

  const dataList = async (queryString) => {
    dispatch(setLoading(true));
    const clientList = await ClientPortal.getListClient(queryString);
    if (!clientList.error && clientList.data) {
      clientList.data.forEach((cc, i) => {
        cc.key = i; // This is necessary to remove warning in console for unique key row
      });
      setState((prevState) => ({
        ...prevState,
        clientsList: get(clientList, "data", []),
        pagination: {
          currentPage: clientList.currentPage ? clientList.currentPage + 1 : paginationDefaults.page,
          size: get(clientList, "pageSize", paginationDefaults.size),
          totalItems: get(clientList, "totalItems", paginationDefaults.totalItems),
        },
      }));
    } else {
      showError(get(clientList, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const deleteCallback = async (id) => {
    confirm({
      title: t("general.ensureDelete"),
      icon: <ExclamationCircleOutlined />,
      onOk: async () => {
        const clients = await ClientPortal.clientRemove(id);
        if (!clients.error) {
          showSuccess();
        } else {
          showError(get(clients, "error.messageCode", "ER000"));
        }
        dataList(filters.string);
      },
      onCancel() {},
    });
  };

  return (
    <>
      <Row justify="end" className="mb-1em">
        <PFButton clickCallback={() => navigate(`new`)} currentIcon={<PlusOutlined className="icon-medium" />} />
      </Row>
      <List
        header={<strong>{t("menuLeft.clients")}</strong>}
        bordered
        size="small"
        pagination={{
          size: "small",
          showSizeChanger: false,
          current: state.pagination.currentPage,
          pageSize: state.pagination.size,
          total: state.pagination.totalItems,
          onChange: (page, pageSize) => {
            const queryString = buildQueryString(filters.obj, { page: page - 1, size: pageSize });
            dispatch(setFilters(queryString));
            setState((prevState) => ({
              ...prevState,
              pagination: {
                currentPage: page,
                size: pageSize,
                totalItems: state.pagination.totalItems,
              },
            }));
            dataList(queryString.string);
          },
        }}
        dataSource={state.clientsList}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Row className="list-actions" key={item.id} align={"middle"}>
                <PFButton
                  type="transparent"
                  className="mr-10"
                  clickCallback={() => navigate(`${item.id}`)}
                  currentIcon={<EditOutlined className="icon-medium" />}
                />

                {!item.deletable ? (
                  <PFButton
                    type="transparent"
                    className="no-pointer"
                    isDisabled={true}
                    currentIcon={<DeleteOutlined className="icon-medium disabled" />}
                  />
                ) : (
                  <PFButton
                    type="transparent"
                    clickCallback={() => deleteCallback(item.id)}
                    currentIcon={<DeleteOutlined className="icon-medium" />}
                  />
                )}
              </Row>,
            ]}
          >
            <List.Item.Meta
              title={
                <div>
                  {item.userSupportPm === null ? <WarningOutlined key={item.id} className="PFred mr-10" /> : ""}{" "}
                  {`${item.id} | ${item.name ? item.name : ""}`}
                </div>
              }
            />
            <div>{item.status}</div>
          </List.Item>
        )}
      />
    </>
  );
};

export default Clients;
